import { Flex } from 'foundations-components/components/Flex';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ChartTypeSelectableBox } from './ChartTypeSelectableBox';
import { jsx as _jsx } from "react/jsx-runtime";
const ChartTypeSelectableBoxes = ({
  value,
  options,
  onChartTypeChange,
  ['data-test-id']: dataTestId = 'chart-type-toggle'
}) => {
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "report-customization-components.customization-components.chartTypeToggle.selectableBoxes.title"
    }),
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsx(Flex, {
      flexDirection: "row",
      gap: "200",
      margin: "50",
      flexWrap: "wrap",
      children: options.map(option => {
        return /*#__PURE__*/_jsx(ChartTypeSelectableBox, {
          "data-test-id": dataTestId,
          option: option,
          value: value,
          onChartTypeChange: onChartTypeChange
        }, option.value);
      })
    })
  });
};
export default ChartTypeSelectableBoxes;